export interface Application {
  id: number;
  name: string;
  is_favourite: boolean;
}

export interface ApplicationSimpe {
  id: number;
  name: string;
}

export interface HealthCheck {
  id: number;
  name: string;
  app: ApplicationSimpe;
  method_name: string;
  created_at: string;
  description: string | null;
  schedule: Schedule | null;
  enabled: boolean;
  latest_status: HealthCheckRunStatus | null;
  last_run_time: string;
  subscribed: boolean;
  auto_pass_until: string | null;
  auto_pass_active: boolean;
  auto_pass_until_formatted: string | null;
  schedule_timeout_config: ScheduleTimeoutConfig;
}

export interface ScheduleTimeoutConfig {
  default_timeout_sec: number;
  max_timeout_sec: number;
  max_cron_timeout_sec: number;
}

export interface Schedule {
  schedule_type: ScheduleType;
  schedule_display: string;
  timeout_sec: number | null;
  cron: string | null;
  minutes: number | null;
  next_run_formatted: string | null;
  next_run: string | null;
}

export enum ScheduleType {
  ONCE = "O",
  MINUTES = "I",
  HOURLY = "H",
  DAILY = "D",
  WEEKLY = "W",
  BIWEEKLY = "BW",
  MONTHLY = "M",
  BIMONTHLY = "BM",
  QUARTERLY = "Q",
  YEARLY = "Y",
  CRON = "C",
}

export interface HealthCheckRun {
  id: number;
  health_check: number;
  status: HealthCheckRunStatus;
  created_at: string;
  completed_at: string;
  detail: string | object;
  triggered_by_user: DisplayUser | null;
}

export interface DisplayUser {
  username: string;
}

export enum HealthCheckRunStatus {
  IN_PROGRESS = "IN_PROGRESS",
  PASS = "PASS",
  FAIL = "FAIL",
  TIMEOUT = "TIMEOUT",
}

export enum ChatStateType {
  SETUP = "SETUP",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum ChatProviderType {
  TELEGRAM = "TELEGRAM",
}

export interface Chat {
  id: number;
  name: string;
  number: string | null;
  reference: string;
  provider: ChatProviderType;
  state: ChatStateType;
  health_check_notifications: boolean;
  audit_notifications: boolean;
  created_at: string;
}
